import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en_US from './en_US.json';
import sv_SE from './sv_SE.json';
import si_LK from './si_LK.json';
import fr_FR from './fr_FR.json';

i18next.use(initReactI18next).init({
  // lng: 'en_US',
  lng: 'en_US', //`${localStorage.getItem('language') !== null ? localStorage.getItem('language') : 'fr_FR'}`, // if you're using a language detector, do not define the lng option
  debug: true,
  resources: {
    en_US: en_US,
    sv_SE: sv_SE,
    si_LK: si_LK,
    fr_FR: fr_FR,
  },
});

export default i18next;
